<template>
  <Patch>
    <h5 slot="title">認證管理</h5>

  </Patch>
</template>

<script>
import Patch from '../common/AdminPatch';

export default {
  name: 'ADCManagement',
  components: {
    Patch,
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmManagement.vue?50d35586